export const API_HOST_LOGIN = 'hostLogin';
export const API_POST_SOCIAL_LOGIN = 'social-login';
export const API_POST_SIGNUP = 'signup';
export const API_POST_SOCIAL_SIGNUP = 'social-signup';
export const API_POST_REQUEST_OTP = 'send-otp';
export const API_POST_VERIFY_OTP = 'verify-otp';
export const API_POST_CHANGE_PASS = 'change-pass';
export const API_POST_RESEND_OTP = 're-send-otp';
export const API_POST_USER_AUTH_OTP = 'verify-user';
export const APP_SETTINGS = 'app-settings';
export const FETCH_VENDOR_DETAILS_NO_AUTH = 'business-details';

export const USERDETAILS = 'user-details';
export const UPLOAD_USER_IMG = 'upload-user-img';
export const CHECK_USER = 'check-user';
export const EDIT_USER = 'edit-user';
export const DELETE_USER_IMG = 'user-img';

export const VENDOR_TYPES = 'vendor-types';
export const VENDOR_CATEGORY = 'vendor-category';
export const VENDOR_SPECIALITY = 'vendor-speciality';
export const CREATE_BUSINESS_PROFILE = 'create-business-profile';
export const CREATE_PACKAGES = 'create-packages';
export const UPDATE_COURSE = 'update-packages';
export const CREATE_PACKAGE_SCHEDULE = 'create-package-schedule';
export const UPDATE_SCHEDULE = 'update-schedule';
export const UPLOAD_VENDOR_IMG = 'upload-vendor-img';
export const UPLOAD_PACKAGE_IMG = 'upload-packages-img';
export const UPLOAD_PACKAGE_INS_IMG = 'upload-pkg-ins-img';
export const SAVE_VENDOR_SOCIALS = 'edit-vendor-socials';
export const FETCH_VENDOR_DETAILS = 'vendor-business-details';
export const FETCH_PKG_LIST = 'pkg-list';
export const FETCH_PKG_DETAILS = 'pkg-details';
export const FETCH_PKGINST_DETAILS = 'pkg-instance-details';
export const SAVE_BUSINESS_PROFILE = 'edit-business-profile';
export const SAVE_BUSINESS_DESC = 'edit-profile-desc';
export const SAVE_BUSINESS_ADDRESS = 'edit-ven-address';
export const SAVE_BUSINESS_IMG = 'remv-vendor-img';
export const SAVE_BUSINESS_PCK = 'edit-vendor-pkg';
export const REMOVE_PKG_IMG = 'remv-pkg-img';
export const REMOVE_PKG_INS_IMG = 'remv-pkg-ins-img';
export const PKG_PRICE_RATE_TYPE = 'price-rate-types';
export const DELETE_PKG_FEATURE = 'remv-pkg-feature';
export const ADD_EDIT_PKG_FEATURE = 'add-edit-pkg-feature';
export const REMOVE_PKG = 'remv-pkg';
export const FETCH_VEN_ADDRESS = 'fetch-ven-address';

export const CREATE_ENQUIRY = 'create-enquery';
export const CREATE_CUSTOMER_ENQUIRY = 'create-customer-enquery';
export const SPECIALITY = 'speciality';
export const ALL_SPECIALITY = 'all-speciality';

export const HOST_ENQUIRY_LIST = "host-enquiry-lists";
export const HOST_ENQUIRY_DETAILS = "host-enquiry-details";
export const EDIT_PARTY_DETAILS_EQ = "edit-party-details-enquiry";
export const EDIT_CUSTOMER_DETAILS = "edit-customer-details";
export const UPDATE_ENQUIRY_PACKAGE = "edit-party-pkg";
export const UPDATE_ENQUIRY_NEWNOTES = "create-notes";
export const DELETE_ENQUIRY = "remv-enq";
export const UPDATE_EQ_DISCOUNT_ADDITIONAL_CHARGE = "edit-additionl-enq-amount";
export const DELETE_PKG_INS_FEATURE = "remv-pkgins-feature";
export const ADD_EDIT_PKG_INS_FEATURE = "add-edit-pkgins-feature";

export const CREATE_BOOKING = "create-booking";
export const CREATE_CUSTOMER_BOOKING = "create-customer-booking";
export const HOST_BOOKING_LIST = "host-booking-lists";
export const BOOKING_DETAILS = "booking-details";
export const HOST_BOOKING_DETAILS = "host-booking-details";
export const UPDATE_BOOKING_PACKAGE = "edit-party-pkg";
export const UPDATE_BOOKING_NEWNOTES = "create-booking-notes";
export const EDIT_PARTY_DETAILS_BK = "edit-party-details-booking";
export const DELETE_BOOKING = "remv-book";
export const UPDATE_BK_DISCOUNT_ADDITIONAL_CHARGE = "edit-additionl-bk-amount";
export const UPADATE_BOOKING_STATUS = "accept-reject-booking";
export const UPDATE_BOOK_SCHEDULE = "update-book-schedule";

export const CREATE_EQ_BK_PKG_INST = "create-enq-book-pkg-instance";
export const CREATE_BOOKING_FROM_ENQUIRY = "existing-enq-to-book";
export const BOOKING_MAKE_PAYMENT = "make-payment";
export const BOOKING_UPDATE_DELETE_PAYMENT = "payment";

export const USER_CONTACT_US = "contact-us";

export const GET_SUBSCRIPTION_PLAN = "subscriptions";
export const UPDATE_SUBSCRIPTION = "user-subscription";

export const UPDATE_SHOW_TO_CUSTOMER = "show-to-customer";
export const VIEW_REVIEW = "view-ven-review";
export const UPLOAD_VENDOR_PRIM_IMG = 'upload-vendor-primary-img';
export const VENDOR_JOB_LIST = 'vendor-job-list';
export const VEN_RES_JOB_LIST = 'ven-res-job-list';
export const VENDOR_JOB_DETAILS = 'vendor-job-details';
export const SEND_RESPONSE = "job-responses";
export const VENDOR_RESPONSE = "resp-by-ven";
export const REGISTER_DEVICE = 'register-device';

export const ALL_NOTIFICATIONS = 'user-notification';
export const NOTIFICATIONS_COUNT = 'user-total-notification';
export const VENDOR_REMV_JOB = 'remv-job-by-ven';

export const ENQ_COUNTS = '/enq-count';
export const BK_COUNTS = '/book-count';

export const ASSIGN_ROLE = 'assign-role';
export const CLEAR_NOTIFICATIONS = 'clear-notifications';
export const FETCH_USER_ROLE = 'user-role-list';

export const ADD_EDIT_FACULTY = 'add-edit-faculty';
export const FACULTY_DETAILS = 'faculty-details';
export const DELETE_FACULTY = 'remv-faculty';

export const UPLOAD_COURSE_VIDEO = 'upload-course-video';
export const UPLOAD_COURSE_INS_VIDEO = 'upload-course-ins-video';
export const UPLOAD_COURSE_PDF = 'upload-course-pdf';

export const CONTENT_TYPE_FETCH = 'content-type';
export const CONTENT_FORMAT_FETCH = 'content-format';
export const CREATE_VENDOR_CONTENT = 'create-vendor-content';
export const FETCH_CONTENT_DETAIL = 'content-detail';

export const FETCH_PUBLISH_LIST = 'publish-list';
export const FETCH_PUBLISH_DETAILS = 'publish-details';
export const FETCH_STUD_ASSIGN_LIST = 'student-assig-list';
export const FETCH_STUD_ASSIGN_DETAIL = 'student-assig-detail';
export const FETCH_ASSIGNMENT_LIST_COURSE = 'assignment-list-course';
export const CREATE_ASSIGNMENT = 'create-assignment';
export const DELETE_VENDOR_CONTENT = 'remv-ven-content';
export const SCHEDULE_DETAILS = 'schedule-detail';
export const UNAUTHORIZE_SCHEDULE_DETAILS = 'unauthorize-schedule-detail';
export const ASSIGNMENT_DETAIL = 'assignment-detail';
export const SCHEDULE_INS_LIST = 'schedule-ins-list';
export const DELETE_SCHEDULE = 'remv-schedule';

export const ASSIGNMENT_DELETE = 'remv-assignment';
export const CREATE_NOTICE = 'add-notice';
export const FETCH_NOTICE_LIST = 'notice-list';
export const FETCH_STUD_NOTICE_LIST = 'student-notice-list';
export const STUD_NOTICE_INST_LIST = 'notice-institute-list';
export const FETCH_NOTICE_DETAILS = 'notice-details';
export const DELETE_NOTICE = 'remv-notice';
export const FETCH_STUDENT_LIST = 'student-list';
export const BATCH_STUDENT_LIST = 'batch-student-list';
export const STUDENT_DETAIL = 'student-detail';

export const UPLOAD_NOTICE_IMG = 'upload-notice-content';
export const GET_BUSINESS_LIST = "search-list";
export const VERIFY_ACTIVATION_CODE = 'verify-activation-code';
export const FETCH_STUD_COURSE_LIST = 'student-course-list';
export const FETCH_STUD_COURSE_DETAIL = 'student-course-detail';
export const UPADATE_ENQUIRY_STATUS = 'accept-reject-package';

export const SUBMIT_ASSIGNMENT = 'submit-assignment';
export const SUBMISSION_DETAILS = 'submission-details';
export const UPLOAD_SUBMISSION_CONTENT = 'upload-submission-content';
export const REMOVE_SUBMISSION_CONTENT = 'remv-submission-content';

export const PUBLIC_CONTENT_LIST = 'public-content-list';


export const FETCH_STUD_ASSESSMENT = 'student-assessment-list';
export const FETCH_STUD_ASSESS_DET = 'student-assessment-detail';

export const CREATE_REVIEW = "create-ven-review";

export const CREATE_JOB = "create-job";
export const PARTY_JOB_LIST = "job-list";
export const JOB_DETAILS = "job-details";
export const JOB_CHAT_DETAILS = "ven-job-resp";
export const DELETE_JOB = "remv-job";
export const COMPLETE_JOB = "comp-job";
export const APP_VERSIONS = "app-versions";

export const GET_REFERRAL_CODE = "referral";
export const FETCH_CONTEST_LIST = 'contest-list';



/* ERROR & TEXT MESSAGES
 */
export const PLEASE_WAIT = 'Please wait..';
export const WENT_WRONG = 'Something went wrong';
export const SUCCESS_USER_ADDED = "User successfully added";
export const ADD_PACKAGE_ERR = "Please add a course to this enquiry before converting";
export const ENQ_ACCEPT_CUST_ERR = 'Enquiry has not been accepted by the customer yet';
export const DEL_CURRICULUM_MSG = "Do you really want to delete this curriculum? This process cannot be undone";
export const BOOKING_COMPLETE_MSG = "Do you really want to convert this enrollment to complete status?";
export const BOOKING_ACCEPT_MSG = "Do you really want to convert this enrollment to accept status?";
export const BOOKING_REJECT_MSG = "Do you really want to convert this enrollment to reject status?";
export const SHOW_CUSTOMER_MSG = "Showed to customer";
export const TRANSAC_MODE_ONLINE = "Online";
export const TRANSAC_MODE_CASH = "Cash";
export const TRANSAC_MODE_CHEQUE = "Cheque";
export const PAYMENT_UPDATED_MSG = "Payment updated";
export const PAYMENT_ADDED_MSG = 'Payment added';
export const ERR_AMOUNT_GREATER = "Amount cannot be greater than due amount";
export const DEL_TRANSAC_MSG = 'Do you really want to delete this transaction? This process cannot be undone';
export const CREATE_PKG_ENQ = 'Create courses before adding to enquiry';
export const CREATE_PKG_BOOK = 'Create courses before adding to enrollment';
export const DEL_BOOK_MSG = 'Do you really want to delete these enrollment? This process cannot be undone';
export const STATUS_CREATED = 1;
export const STATUS_ONGOING = 2;
export const STATUS_COMPLETE = 3;
export const COMPLETE_STATUS = 'Completed';
export const STATUS_DELETE = 4;
export const STATUS_DELETED = 'Deleted';
export const STATUS_ACCEPT = 5;
export const STATUS_REJECT = 6;
export const STATUS_ACCEPTED_ICON = 'Accepted';
export const STATUS_DECLINED_ICON = 'Declined';
export const STATUS_DEMO_COMP = 'Demo Completed';
export const STATUS_ACTIVE = 'Active';
export const STATUS_INPROGRESS = 'In Progress';
export const STATUS_INACTIVE = 'Inactive';
export const STATUS_SHOW_ONLINE = 'Available';
export const STATUS_NOTSHOW_ONLINE = 'Unavailable';
export const ACTIVE_STATUS = 1;
export const INACTIVE_STATUS = 0;
export const SUSPEND_STATUS = 2;
export const STATUS_SUSPENDED = 'Suspended';
export const CANCEL_STATUS = 4;
export const STATUS_CANCELLED = 'Cancelled';
export const BATCH_STATUS_DELETE = 5;
export const BATCH_STATUS_DELETED = 'Deleted';
export const DATE_PASSED_ICON = 'rng-icn';
export const IN_PROGRESS_ICON = 'rgt-icn';
export const ACCEPTED_ICON = 'accept-icn';
export const REJECTED_ICON = 'reject-icn';
export const ENTER_VALID_NOTES = 'Please enter valid notes';
export const SUCCESS_BOOK_CREATED = "Enrollment created successfully";
export const EXTENSION_JPG = '.jpg';
export const EXTENSION_JPEG = '.jpeg';
export const EXTENSION_PNG = '.png';
export const ENTER_VALID_DATA = 'Please enter valid data';
export const RATE_TYPE_FIXED = "Fixed";
export const RATE_TYPE_PER_MONTH = "Per month";
export const RATE_TYPE_PER_HOUR = "Per hour";
export const RATE_TYPE_PER_CLASS = "Per Class";
export const RATE_TYPE_FREE = "Free";
export const ENQ_COMPLETE_MSG = "Do you really want to convert this enquiry to complete status?";
export const DEL_ENQ_MSG = "Do you really want to delete these enquiry? This process cannot be undone";
export const SUCCESS_NOTES_ADDED = 'Notes added successfully';
export const SUCCESS_ENQ_CREATED = "Enquiry created successfully";
export const ENTER_SOME_TEXT = 'Please enter some text';
export const REPLY_BY_TEACHER = 'teacher-chat';
export const REPLY_BY_STUDENT = 'student-chat';
export const DEL_JOB_MSG = 'Do you really want to delete these job? This process cannot be undone';
export const SELECT_PLAN = "Please select a plan to continue";
export const CREATE_PKG = "Create courses before adding to enquiry/enrollment";
export const CREATE_PKG_TEMPLATE = "Create courses before adding to ";
export const SUCCESS_MSG_SENT = 'Message sent successfully.';
export const ENTER_YOUR_MSG = 'Please enter your message';
export const VALID_EMAIL_MSG = 'Please enter valid email address';
export const ERR_INCORRECT_OTP = 'Incorrect OTP';
export const SOCIAL_SIGNUP_GOOGLE = 'google';
export const SOCIAL_SIGNUP_FACEBOOK = 'facebook';
export const USE_EMIAL_PASSWORD = 'You should use email and password';
export const ACCEPT_TERMS_POLICY = 'Please accept our Terms of services and Privacy policy';
export const HEADER_PICK_APP = 'Pick an app';
export const PASSWORD_UPDATE_MSG = 'Password updated';
export const HEADER_ARE_YOU_SURE = "Are You Sure?";
export const JOB_COMP = "Do you really want to convert this post request to complete status?";
export const DEL_SCHEDULE_MSG = "Do you really want to delete this batch? This process cannot be undone";
export const NO_PKG = "No course added yet";
export const DIFF_VEN_ENQ = "This enquiry is of another teacher/institute";
export const ACCEPT_PKG = "Accept the Course assigned to this Enquiry";
export const SELECT_LOCATION = "Please select a location to search courses";
export const PKG_ACC = "Course accepted";
export const PKG_REJ = "Course declined";
export const ACC_PKG = "Do you really want to accept this Course?";
export const REJ_PKG = "Do you really want to decline this Course?";
export const GO_TO_SEARCH = "Seach for teachers/institutes to create new enrollment";

export const LOGIN_POST_TEACHER = "Please login to post teacher request";
export const ENTER_TEXT = "Please enter some text";

// APP-DOWNLOAD //

export const APP_DOWNLOAD = "Some features are only available on our App StudentEd Students currently. Please download the App using the link below";

// Search//
export const HOME_COURSE_CATEGORY = "View hundreds of classes available across many learning categories & specialities";

export const SEARCH_DOWNLOADAPP = "Download the StudentEd App for Students to easily find best online classes and start learning";
export const SEARCH_POSTTEACHER = "Are you looking for a teacher? Post your requirement to reach our best teaching professionals and arrange free  demo class ";
export const SEARCH_SPECIALITY = "Learning Categories and Specialities";

export const HOW_IT_WORKS_STEP1 ="Find classes from highly experienced and quality teaching professionals";
export const HOW_IT_WORKS_STEP2 = "Request a Demo Class to assess the class";
export const HOW_IT_WORKS_STEP3 = "Complete the enrolment and manage class fee payment";
export const HOW_IT_WORKS_STEP4 = "Start your online learning journey with best teachers ";

// PROFILE(profile.component.ts)//
export const PROFILE_REVIEW="View hundreds of classes available across many learning categories & specialities !";
export const SHARE_PROFILE="Share profile with your friends & family";
// CLASS SEARCH RESULTS 
export const SEARCH_VIEW_ALL="Select a class and request for free demo to start your online learning experience with quality & eperienced teaching professionals "

// HOW IT WORKS//

export const HOW_IT_WORKS_FEATURES = "StudentEd provides a complete online learning experience with some amazing class management features";
export const HOW_IT_WORKS_DOWNLOAD_APP = "Download the StudentEd App for Students to easily find best online classes and start learning";
export const HOW_IT_WORKS_PROFILE = "Manage your profile details";
export const HOW_IT_WORKS_ENROLLMENT = "Enrol and manage payment for your classes";
export const HOW_IT_WORKS_CALENDER = "Manage your classes schedule in a calendar view";
export const HOW_IT_WORKS_ASSIGNMENT = "Submit homework, tests, assignment for your online classes";
export const HOW_IT_WORKS_ASSESSMENT = "Receive regular feedbacks and progress report from teachers";
export const HOW_IT_WORKS_NOTICE = "Get notifications or announcements from teachers";
export const HOW_IT_WORKS_ENQUIRY = "Request for Demo Class before enrolling";
export const HOW_IT_WORKS_MYPOSTS = "Post custom requirements for a teacher or coach";
export const JOINING_DETAILS = "Details for joining demo class will be available after tutor adds the information";

export const WHY_HOW_STUDENT_APP_TEXT = "StudentEd App offers best online learning experience with fully integrated online classes management solution";
export const WHY_STUDENT_APP_TEXT1 = "1-1 classes + small groups classes";
export const WHY_STUDENT_APP_TEXT2 = "Qualified, Experienced, Professional & Verified teachers";
export const WHY_STUDENT_APP_TEXT3 = "Free Demo classes";
export const WHY_STUDENT_APP_TEXT4 = "Flexible class times to meet your timezone";
export const WHY_STUDENT_APP_TEXT5 = "Secure online payments";
export const WHY_STUDENT_APP_TEXT6 = "Flexible joining options. No contract. Stop when you like";
export const WHY_STUDENT_APP_TEXT7 = "Classes available for many academics subjects and add on learning";
export const WHY_STUDENT_APP_TEXT8 = "Online classes for Musical Instruments, Dance, Singing";
export const WHY_STUDENT_APP_TEXT9 = "Online classes for many regional languages";
export const WHY_STUDENT_APP_TEXT10 = "Supported with complete online learning management App";
// HOW IT WORKS TEACHER//
export const HOW_IT_WORKS_TEACHER_STEP1="Setup your teacher or institute profile with your qualifications, expecrience, speciality";
export const HOW_IT_WORKS_TEACHER_STEP2="Add Classes you can offer with curriculum details, available timings, pricing and grades/age-group ";
export const HOW_IT_WORKS_TEACHER_STEP3="Provide Demo class before enrolling students and start teaching online";
export const HOW_IT_WORKS_FEATURE_TEACHER="StudentEd Connect App comes with great features for teaching and managing online classes";
export const HOW_IT_WORKS_TEACHER_PROFILE = "Showcase your teaching profile with details of your qulaification, experience, speciality and more";
export const HOW_IT_WORKS_TEACHER_CLASSES = "Manage all the classes you offer along with multiple batches, class curriculum and pricing";
export const HOW_IT_WORKS_TEACHER_ENROLLMENT = "Enrol students after demo and process class fees";
export const HOW_IT_WORKS_TEACHER_CALENDER = "Manage all your schedule of classes in one place";
export const HOW_IT_WORKS_TEACHER_ASSIGNMENT = "Create homework, tests or other assignments";
export const HOW_IT_WORKS_TEACHER_ACCESSMENT = "Provide regular feedback and assessments to your students";
export const HOW_IT_WORKS_TEACHER_NOTICE = "Send notifications or announcements to your students";
export const HOW_IT_WORKS_TEACHER_ENQUIRY = "Manage Demo enquiries from learners and setup Demo classes";
export const HOW_IT_WORKS_TEACHER_NEWJOBS = "View & respond to new requirements from Students";
export const HOW_IT_WORKS_TEACHER_PUBLISH = "Publish Demo videos, notes, tutorials and other content";
export const HOW_IT_WORKS_TEACHER_DOWNLOAD_APP = "Download StudentEd Connect App for Teachers and start teaching online";

export const LEARNING_MANAGEMENT_TEXT = "StudentEd provides a fully integrated online learning managemnet solution to provide best expereince with online classes.";
export const DEMO_ENROLLMENT_TEXT = "Setting up Demo classes is important for both you and your students to get to know each other and make the right choice.";
export const LOGIN_DOWNLOAD_TEACHER_APP = "Download StudentEd Connect App for Teachers and start teaching online";
export const LOGIN_DOWNLOAD_STUDENT_APP = "Download StudentEd Students App to Find Online Classes, Request Demo and Start learning";
export const PROFILE_SETUP = "Creating a perfect teacher or institute profile is the first step in your online teaching journey, StudentEd App lets you share all the important details like Qualifications, Experience, Speciality and many more with potential students looking for online classes";
export const LOGIN_APPLE_STORE_LINK= "https://apps.apple.com/gb/app/studented/id1531382870";
export const LOGIN_PLAYSTORE_LINK="https://play.google.com/store/apps/details?id=com.studented.students";


export const WHY_STUDENT_APP_TEXT11 = "1-1 classes + small groups classes";
export const WHY_STUDENT_APP_TEXT12 = "Qualified, Experienced, Professional & Verified teachers";
export const WHY_STUDENT_APP_TEXT13 = "Free Demo classes";
export const WHY_STUDENT_APP_TEXT14 = "Flexible class times to meet your timezone";
export const WHY_STUDENT_APP_TEXT15 = "Secure online payments";
export const WHY_STUDENT_APP_TEXT16 = "Flexible joining options. No contract. Stop when you like";
export const WHY_STUDENT_APP_TEXT17 = "Classes available for many academics subjects and add on learning";
export const WHY_STUDENT_APP_TEXT18 = "Online classes for Musical Instruments, Dance, Singing";
export const WHY_STUDENT_APP_TEXT19 = "Online classes for many regional languages";
export const WHY_STUDENT_APP_TEXT20 = "Supported with complete online learning management App";

export const CLASS_MODE = [
    {
      id: 'Online',
      name: "Online"
    },
    {
      id: 'Classroom',
      name: "Classroom"
    },
    {
      id: 'Self-Paced/Recorded',
      name: "Recorded"
    }
  ];